import { request } from "../../../Services/Api"

export const getRequestsAutoRefundFilterOptions = () =>
  request.api.get("/user/requests/auto-refund-amount/filter_options/")
export const getAutoRefundRequests = (params) =>
  request.api.get(`/user/requests/auto-refund-amount/`, params)
export const updateAutoRefundRequests = ({ id, ...params }) =>
  request.api.patch(`/user/requests/auto-refund-amount/${id}/`, params)
export const deleteAutoRefundRequests = (id) =>
  request.api.delete(`/user/requests/auto-refund-amount/${id}/`)
export const getRequestsAutoRefundExport = ({ file_name, ...params }) =>
  request.api.get(`/user/requests/auto-refund-amount/export_auto_refund_amount_data/`, params)
